import { parseSseChunk } from "./assistantProtocol";

const normalize = (url) => (url ? String(url).trim().replace(/\/+$/, "") : "");

/** The AI service's base URL. Empty until it is deployed, which the UI shows as "not connected". */
export const AI_API_URL = normalize(process.env.REACT_APP_AI_API_URL);

export const assistantConfigured = () => Boolean(AI_API_URL);

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const failureMessage = async (response) => {
  try {
    const body = await response.json();
    return body?.message || body?.errorMessage || `The assistant answered ${response.status}`;
  } catch {
    return `The assistant answered ${response.status}`;
  }
};

/**
 * Sends one user turn and calls `onEvent` for every streamed event until the reply ends.
 * Pass an AbortSignal to stop it. Rejects on network or HTTP failure.
 */
export const streamAssistantChat = async ({ body, onEvent, signal }) => {
  const response = await fetch(`${AI_API_URL}/agent/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream", ...authHeaders() },
    body: JSON.stringify(body),
    signal,
  });
  if (!response.ok || !response.body) throw new Error(await failureMessage(response));

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const { events, rest } = parseSseChunk(buffer);
    buffer = rest;
    events.forEach(onEvent);
  }
  const { events } = parseSseChunk(`${buffer}\n\n`);
  events.forEach(onEvent);
};

const decide = async (proposalId, decision) => {
  const response = await fetch(`${AI_API_URL}/agent/proposals/${proposalId}/${decision}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeaders() },
  });
  if (!response.ok) throw new Error(await failureMessage(response));
  return response.json().catch(() => ({}));
};

export const approveAssistantProposal = (proposalId) => decide(proposalId, "approve");
export const rejectAssistantProposal = (proposalId) => decide(proposalId, "reject");
